const btnForgotPassword = {
  text: 'Restablecer contraseña'
};

export default btnForgotPassword;
